import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Button} from '@material-ui/core';
import Icon from '@mdi/react'

const useStyles = makeStyles(theme => ({
  label: {
    lineHeight: 'normal'
  },
  button: {
    marginBottom:'15px',
    padding:'2px 4px',
    textTransform:'none',
    background:'rgba(255,192,203,0.6)',
    fontWeight:'600',
    fontSize:16,
  }
  }));

export default function LinkButton(props) {
    const classes = useStyles();
   
return (
        <Button className={classes.button}  classes={{label:classes.label}} href={props.link} target="_blank" onClick={props.onClick}>
           <Icon    path={props.icon}
                    style={{marginRight:'5px'}}
                    size={1}/>
                    {props.text}
        </Button>
    );
  }